module.exports = __webpack_public_path__ + "static/funnels5-64f579a3df1e776df12af7eb177ab5e9.png";